import { TableRow, TableCell, Typography, Button } from '@mui/material'
import type { FC } from 'react'
import { Link } from 'react-router-dom'

import type { TransformedExecutiveBySquadData } from '@/lib/apollo/query/getExecutivesBySquad/dataTransformations/types'
import { rowHeight } from '@/utils/table'

export type Props = {
  executive: TransformedExecutiveBySquadData
}

const Row: FC<Props> = ({ executive }) => (
  <TableRow hover key={executive.userId} sx={{ height: rowHeight }}>
    <TableCell component="th" scope="row">
      <Typography variant="body2" noWrap>
        {executive.fullName}
      </Typography>
    </TableCell>
    <TableCell component="th" scope="row">
      <Typography variant="body2" noWrap>
        {executive.skillLevel}
      </Typography>
    </TableCell>
    <TableCell component="th" scope="row">
      &nbsp;
    </TableCell>
    <TableCell align="right" padding="none">
      <Button
        size="small"
        variant="text"
        component={Link}
        to={`/executive/${executive.userId}`}
        sx={{ whitespace: 'noWrap' }}
      >
        View executive
      </Button>
    </TableCell>
  </TableRow>
)

export default Row
